// Function to load external scripts dynamically
function loadScript(src, integrity = "", crossorigin = "") {
  const script = document.createElement("script");
  script.src = src;
  if (integrity) script.integrity = integrity;
  if (crossorigin) script.crossOrigin = crossorigin;
  script.async = false; // Important for keeping order of scripts
  document.body.appendChild(script);
}

// Function to load external stylesheets dynamically
function loadStylesheet(href) {
  const link = document.createElement("link");
  link.href = href;
  link.rel = "stylesheet";
  document.head.appendChild(link);
}

export { loadScript, loadStylesheet };
